<template>
    <header>
        <img class="header-logo" src="../../assets/images/logo_small.png" alt="header_logo" v-show="logo_show" @click="toTop">
        <nav>
            <div v-for="(item, index) in navList" :key="index" :class="['nav-li', item.class]" @click="goTo(index)">
                <transition></transition>
                <img class="nav-li__off" :src="item.off" alt="">
                <img v-show="NAV_ACTIVE_INDEX == index+2" class="nav-li__on" :src="item.on" alt="">
            </div>
        </nav>
    </header>
</template>

<script>
export default {
    name: "",

    components: {
    },
    data: () => ({
        logo_show: true,
        navList: [
            {
                class: "nav-li__news",
                off: require("../../assets/images/home/header/news_off.png"),
                on: require("../../assets/images/home/header/news_on.png")
            },
            {
                class: "nav-li__world",
                off: require("../../assets/images/home/header/world_off.png"),
                on: require("../../assets/images/home/header/world_on.png")
            },
            {
                class: "nav-li__character",
                off: require("../../assets/images/home/header/character_off.png"),
                on: require("../../assets/images/home/header/character_on.png")
            },
            {
                class: "nav-li__system",
                off: require("../../assets/images/home/header/system_off.png"),
                on: require("../../assets/images/home/header/system_on.png")
            },
            {
                class: "nav-li__gallery",
                off: require("../../assets/images/home/header/gallery_off.png"),
                on: require("../../assets/images/home/header/gallery_on.png")
            },

            {
                class: "nav-li__spec",
                off: require("../../assets/images/home/header/spec_off.png"),
                on: require("../../assets/images/home/header/spec_on.png")
            }
        ],
    }),
    created() {
    },
    mounted() {
    },
    watch: {
        NAV_ACTIVE_INDEX(val) {
            if(val == 1) {
                this.logo_show = false
            } else {
                this.logo_show = true
            }
        }
    },
    computed: {
        NAV_ACTIVE_INDEX() {		// 导航栏激活指数
            if(this.$store.state.HOME_FULLPAGE) {       // 异步对象
                return this.$store.state.HOME_FULLPAGE.activeIndex;
            } else {
                return -1;
            }
        },
        HOME_FULLPAGE() {
            return this.$store.state.HOME_FULLPAGE;
        }
    },
    methods: {
        goTo(index) {
            this.HOME_FULLPAGE.goTo(index+2)
        },
        toTop() {
            this.HOME_FULLPAGE.goTo(1)
        }
    },
};
</script>

<style lang="scss" scoped>
header {
    width: 100%;
    min-width: $pageMinWidth;
    height: pxTorem(55px);
    background: rgba(0, 0, 0, 0.75);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;

    .header-logo {
        position: absolute;
        width: pxTorem(254px);
        top: pxTorem(10px);
        left: pxTorem(23px);
        cursor: pointer;
    }

    nav {
        height: 100%;
        display: flex;
        justify-content: flex-end;
        flex-direction: row;
        box-sizing: border-box;
        padding-right: pxTorem(28px);
        .nav-li {
            position: relative;
            color: #fff;
            cursor: pointer;
            height: 100%;
            
            img {
                display: block;
                height: 100%;
            }

            &:not(:first-of-type) {
                margin-left: pxTorem(-57px);
            }

            &__on {
                position: absolute;
                top: 0;
                left: 0;
                z-index: 999;
                transition: all .3s;
            }
        }
    }
}
</style>
